<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Serviços Tomados</h1>
            <p class="welcome-message">Notas fiscais de serviços contratados (NFS-e de entrada)</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        @if (podeInserir) {
        <button type="button" mat-flat-button class="btn-primary" routerLink="/suprimentos/servicos-tomados/incluir">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Incluir Nota
        </button>
        }
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="Número da nota ou remetente" />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 filter-container">
          <!-- Seletor de Período -->
          <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
            [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
            <div class="periodo-menu-content">
              <div>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoServicoTomadoEnum.Hoje); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoServicoTomadoEnum.Hoje">
                  <span>hoje</span>
                  @if (periodoSelecionado === PeriodoServicoTomadoEnum.Hoje) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoServicoTomadoEnum.DaSemana); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoServicoTomadoEnum.DaSemana">
                  <span>desta semana</span>
                  @if (periodoSelecionado === PeriodoServicoTomadoEnum.DaSemana) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoServicoTomadoEnum.DoMes); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoServicoTomadoEnum.DoMes">
                  <span>do mês</span>
                  @if (periodoSelecionado === PeriodoServicoTomadoEnum.DoMes) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoServicoTomadoEnum.Ultimos30Dias); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoServicoTomadoEnum.Ultimos30Dias">
                  <span>últimos 30 dias</span>
                  @if (periodoSelecionado === PeriodoServicoTomadoEnum.Ultimos30Dias) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoServicoTomadoEnum.DoIntervalo); $event.stopPropagation()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoServicoTomadoEnum.DoIntervalo">
                  <span>do intervalo</span>
                  @if (periodoSelecionado === PeriodoServicoTomadoEnum.DoIntervalo) {
                  <mat-icon>check</mat-icon>
                  }
                </button>

                @if (periodoSelecionado === PeriodoServicoTomadoEnum.DoIntervalo) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input matInput [matDatepicker]="pickerDe" formControlName="dataDe" />
                    <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDe></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input matInput [matDatepicker]="pickerAte" formControlName="dataAte" />
                    <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerAte></mat-datepicker>
                  </mat-form-field>

                  <div class="periodo-intervalo-actions">
                    <button type="button" mat-button class="btn-secondary"
                      (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                      Cancelar
                    </button>
                    <button type="button" mat-flat-button class="btn-primary"
                      (click)="aplicarPeriodo(periodoMenuTrigger)">
                      Aplicar
                    </button>
                  </div>
                </div>
                }
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosStatus" [matBadgeHidden]="qtdFiltrosStatus === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>
                <div class="filter-menu__form">
                  <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="idStatusFiscalNFSeEntrada">
                      <mat-option [value]="null">Todos</mat-option>
                      @for (opcao of statusOpcoes; track opcao.id) {
                      <mat-option [value]="opcao.id">{{ opcao.descricao }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    <app-alert-card type="info" class="mb-3">
      <strong>O lançamento financeiro não é gerado automaticamente.</strong> Após registrar o serviço tomado, lance
      manualmente em <strong>Lançar financeiro</strong>.
    </app-alert-card>

    @if (_listaResponse && _dataSource.data.length > 0) {
    <div class="table-container desktop-view">
      <table mat-table [dataSource]="_dataSource">
        <ng-container matColumnDef="numero">
          <th mat-header-cell *matHeaderCellDef>Nº Documento</th>
          <td mat-cell *matCellDef="let row">{{ row.numeroNFSe }}</td>
        </ng-container>

        <ng-container matColumnDef="emitente">
          <th mat-header-cell *matHeaderCellDef>Remetente</th>
          <td mat-cell *matCellDef="let row">{{ row.emitenteNome }}</td>
        </ng-container>

        <ng-container matColumnDef="emissao">
          <th mat-header-cell *matHeaderCellDef>Emissão</th>
          <td mat-cell *matCellDef="let row">{{ row.datetimeEmissaoDps | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="entrada">
          <th mat-header-cell *matHeaderCellDef>Entrada</th>
          <td mat-cell *matCellDef="let row">{{ row.dataExecucaoEntrada | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span [class]="statusBadgeClass(row.idStatusFiscalNFSeEntrada)">{{ statusLabel(row.idStatusFiscalNFSeEntrada)
              }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef>Tags</th>
          <td mat-cell *matCellDef="let row">
            <div class="tags-cell">
              @for (tag of row.tags; track tag.idTagServicoTomado) {
              <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="valorTotal">
          <th mat-header-cell *matHeaderCellDef class="text-end">Valor Total</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.valorTotal | abnt:'preco':2 }}</td>
        </ng-container>

        <ng-container matColumnDef="valorLiquido">
          <th mat-header-cell *matHeaderCellDef class="text-end">Valor Líquido</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.valorLiquido | abnt:'preco':2 }}</td>
        </ng-container>

        <ng-container matColumnDef="integracao">
          <th mat-header-cell *matHeaderCellDef>Integração</th>
          <td mat-cell *matCellDef="let row">
            @if (integracoes(row).length) {
            <span class="indicador-grid">
              @for (integracao of integracoes(row); track integracao.sigla) {
              <span class="indicador indicador-sm" [style.--indicador-cor]="integracao.cor" [matTooltip]="integracao.rotulo"
                [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
              }
            </span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
          <td mat-cell *matCellDef="let row" class="text-center">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              @if (podeAlterar) {
              <span class="menu-item-tooltip-wrapper" matTooltip="Exclua o financeiro para editar."
                [matTooltipDisabled]="!row.isFinanceiroLancado" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="editar(row)" [disabled]="row.isFinanceiroLancado">
                  <span class="material-symbols-outlined">edit</span>
                  <span>Editar</span>
                </button>
              </span>
              }
              <button mat-menu-item (click)="verHistorico(row)">
                <span class="material-symbols-outlined">history</span>
                <span>Ver histórico</span>
              </button>
              <button mat-menu-item (click)="imprimir(row)">
                <span class="material-symbols-outlined">print</span>
                <span>Imprimir</span>
              </button>
              <!-- Sem financeiro lançado: lançar (permissão de inserir). Lançado: excluir (apaga a conta, permissão
                   própria). A recusa por parcela paga ou liquidada vem do Finanças. -->
              @if (podeInserir && !row.isFinanceiroLancado) {
              <button mat-menu-item (click)="lancarFinanceiro(row)">
                <span class="material-symbols-outlined">payments</span>
                <span>Lançar financeiro</span>
              </button>
              }
              @if (podeExcluirFinanceiro && row.isFinanceiroLancado) {
              <button mat-menu-item (click)="excluirFinanceiro(row)">
                <span class="material-symbols-outlined">undo</span>
                <span>Excluir financeiro</span>
              </button>
              }
              <button mat-menu-item (click)="editarTags(row)">
                <span class="material-symbols-outlined">label</span>
                <span>Editar tags</span>
              </button>
              @if (podeInserir) {
              <button mat-menu-item [routerLink]="['/suprimentos/servicos-tomados/incluir']"
                [queryParams]="{ clonarDe: row.idNFSeEntrada }">
                <span class="material-symbols-outlined">content_copy</span>
                <span>Clonar</span>
              </button>
              }
              @if (podeExcluir) {
              <span class="menu-item-tooltip-wrapper" matTooltip="Exclua o financeiro para excluir o serviço tomado."
                [matTooltipDisabled]="!row.isFinanceiroLancado" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="excluir(row)" [disabled]="row.isFinanceiroLancado">
                  <span class="material-symbols-outlined">delete</span>
                  <span>Excluir</span>
                </button>
              </span>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <div class="mobile-view">
      @for (row of _dataSource.data; track row.idNFSeEntrada) {
      <div class="card-mobile mb-3">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <span class="text-bold">Nº {{ row.numeroNFSe }}</span>
            <small>{{ row.emitenteNome }}</small>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span [class]="statusBadgeClass(row.idStatusFiscalNFSeEntrada)">{{ statusLabel(row.idStatusFiscalNFSeEntrada) }}</span>
            <button mat-icon-button [matMenuTriggerFor]="menuMobile">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #menuMobile="matMenu">
              @if (podeAlterar) {
              <span class="menu-item-tooltip-wrapper" matTooltip="Exclua o financeiro para editar."
                [matTooltipDisabled]="!row.isFinanceiroLancado" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="editar(row)" [disabled]="row.isFinanceiroLancado">Editar</button>
              </span>
              }
              <button mat-menu-item (click)="verHistorico(row)">Ver histórico</button>
              <button mat-menu-item (click)="imprimir(row)">Imprimir</button>
              @if (podeInserir && !row.isFinanceiroLancado) {
              <button mat-menu-item (click)="lancarFinanceiro(row)">Lançar financeiro</button>
              }
              @if (podeExcluirFinanceiro && row.isFinanceiroLancado) {
              <button mat-menu-item (click)="excluirFinanceiro(row)">Excluir financeiro</button>
              }
              <button mat-menu-item (click)="editarTags(row)">Editar tags</button>
              @if (podeInserir) {
              <button mat-menu-item [routerLink]="['/suprimentos/servicos-tomados/incluir']"
                [queryParams]="{ clonarDe: row.idNFSeEntrada }">Clonar</button>
              }
              @if (podeExcluir) {
              <span class="menu-item-tooltip-wrapper" matTooltip="Exclua o financeiro para excluir o serviço tomado."
                [matTooltipDisabled]="!row.isFinanceiroLancado" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="excluir(row)" [disabled]="row.isFinanceiroLancado">Excluir</button>
              </span>
              }
            </mat-menu>
          </div>
        </div>
        <div class="card-body-mobile p-3">
          @if (row.tags?.length) {
          <div class="tags-cell mb-2">
            @for (tag of row.tags; track tag.idTagServicoTomado) {
            <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
            }
          </div>
          }
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Emissão</small>
              <span>{{ row.datetimeEmissaoDps | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Entrada</small>
              <span>{{ row.dataExecucaoEntrada | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Valor Total</small>
              <span>{{ row.valorTotal | abnt:'preco':2 }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Valor Líquido</small>
              <span class="text-bold">{{ row.valorLiquido | abnt:'preco':2 }}</span>
            </div>
            @if (integracoes(row).length) {
            <div class="col-6 mb-2">
              <small class="d-block">Integração</small>
              <span class="indicador-grid">
                @for (integracao of integracoes(row); track integracao.sigla) {
                <span class="indicador indicador-sm" [style.--indicador-cor]="integracao.cor" [matTooltip]="integracao.rotulo"
                  [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
                }
              </span>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <div class="d-flex justify-content-center py-3">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span><mat-icon>expand_more</mat-icon> Ver Mais</span>
        }
      </button>
    </div>
    } @else if (_isLoading) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <app-empty-list [title]="'Nenhum lançamento encontrado'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>